import { render } from "./StickerMessage.vue?vue&type=template&id=66a3c6cf"
import script from "./StickerMessage.vue?vue&type=script&lang=js"
export * from "./StickerMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__